const REFRESHMENT_UPDATED = (state, Refreshment) => {
  state.Refreshment = Refreshment
}

const REFRESHMENT_ITEM = (state, refreshmentItem) => {
  state.refreshmentItem = refreshmentItem
}

const LIST_RECEIPT_PAX_UPDATE = (state, listReceiptPax) => {
  state.listReceiptPax = listReceiptPax
}

const INFO_BANK_PAX_UPDATE = (state, InfoBankPax) => {
  state.InfoBankPax = InfoBankPax
}

const REFRESHMENT_INFO = (state, data) => {
  state.refreshmentInfo = data
}

const UPDATE_CURRENCIES = (state, data) => {
  state.Currencies = data
}

const UPDATE_COUNTRYS = (state, data) => {
  state.Countrys = data
}

const UPDATE_DATA_BANK = (state, data) => {
  state.dataBank = data
}

const REFRESHMENT_PRICE = (state, data) => {
  state.refreshmentPrice = data
}

export default {
  REFRESHMENT_UPDATED,
  REFRESHMENT_ITEM,
  LIST_RECEIPT_PAX_UPDATE,
  INFO_BANK_PAX_UPDATE,
  REFRESHMENT_INFO,
  UPDATE_CURRENCIES,
  UPDATE_DATA_BANK,
  REFRESHMENT_PRICE,
  UPDATE_COUNTRYS
}
